module.exports = __webpack_public_path__ + "static/media/Zailesh.cfa4e7e6.jpeg";